/**
 * Parse a driver filter string into a GraphQL filter object.
 *
 * Supports three formats:
 *  - "Name - ID" (e.g. "John Doe - 1001") → filters by employeeId
 *  - Pure numeric (e.g. "1001") → filters by employeeId
 *  - Anything else → filters by employeeName (contains)
 *
 * Returns null if the input is empty.
 */
const parseDriverFilter = (input) => {
  if (!input || !input.trim()) return null;

  const trimmed = input.trim();

  // "Name - ID" format
  const parts = trimmed.split(' - ');
  if (parts.length === 2 && !isNaN(parts[1])) {
    return { employeeId: { eq: parseInt(parts[1], 10) } };
  }

  // Pure numeric input
  if (/^\d+$/.test(trimmed)) {
    return { employeeId: { eq: parseInt(trimmed, 10) } };
  }

  // Free-text name search
  return { employeeName: { contains: trimmed } };
};

export default parseDriverFilter;
